
























































































































import {Component, Mixins, Watch} from 'vue-property-decorator';
import AuthorityGroups from '@/components/admin/mixins/AuthorityGroups';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import {AdminAddParameters, PopupRequestData} from '@/types';
import {AdminRole} from 'supporter';
import {addDay} from '@/utils/dateUtils';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
type NeedCheckPropName = 'adminName' | 'emailId' | 'emailDomain';
import TextInput from '@/pro/components/common/input/TextInput.vue';
import LayerPopup from '@/components/LayerPopup.vue';

@Component({
  components: {PageFormSelect, DateCalendar, TextInput, LayerPopup}
})
export default class AdminAdd extends Mixins(AuthorityGroups) {
  private isAuthorityGroupsSettingShow: boolean = false;
  private get adminRole() {
    return this.adminAddParameters.adminRole;
  }
  @Watch('adminRole')
  onAdminRoleChange(newVal: string) {
    if (newVal === 'NORMAL') {
      this.isAuthorityGroupsSettingShow = true;
    } else {
      this.isAuthorityGroupsSettingShow = false;
    }
  }

  private get adminName() {
    return this.adminAddParameters.adminName.trim();
  }

  private get emailId() {
    return this.adminAddParameters.emailId.trim();
  }

  private get emailDomain() {
    return this.adminAddParameters.emailDomain.trim();
  }

  private get adminEmail() {
    return this.emailId + '@' + this.emailDomain;
  }

  private get authorityGroupNo() {
    return this.adminAddParameters.authorityGroupNo;
  }

  private adminAddParameters: AdminAddParameters = {
    adminRole: '',
    adminName: '',
    emailId: '',
    emailDomain: '',
    externalAccess: 'false',
    authorityGroupNo: '0',
    expireDate: '',
    reasonDetail: '',
  };

  private expireDate = addDay(new Date(), 30);

  private calendarOption = {
    fromRanges: addDay(new Date(), 0)
  };

  private useExpire = 'false';

  private changeUseExpire() {
    if (this.useExpire === 'true') {
      this.adminAddParameters.expireDate = this.expireDate;
    }
    else {
      this.adminAddParameters.expireDate = '';
      this.expireDate = addDay(new Date(), 30);
    }
  }

  private regObj: {adminName: RegExp; emailId: RegExp; emailDomain: RegExp} = {
    adminName: new RegExp('[a-zA-Z0-9ㄱ-힣]|\\s{0,1}', 'g'),
    emailId: new RegExp('[a-zA-Z0-9+\\-_!#$%&\'*/=?^`{|}~.]', 'g'),
    emailDomain: new RegExp('[a-zA-Z0-9\\-.]', 'g')
  };

  private errObj: {adminName: boolean; emailId: boolean; emailDomain: boolean} = {
    adminName: false,
    emailId: false,
    emailDomain: false
  };

  private isOpenExternalGuideModal = false;

  private openExternalModal() {
    this.isOpenExternalGuideModal = true;
  }

  private externalAccessGuideData: PopupRequestData = {
    id: 'externalAccessGuide',
    width: 560,
    title: '외부접속',
    hasConfirmBtn: false
  };


  private stringHandle(value: string, prop: NeedCheckPropName) {
    const validArr = value.match(this.regObj[prop]);
    if (!value.length) {
      return this.errObj[prop] = false;
    }
    if (!validArr || validArr.join('').length < value.length) {
      this.errObj[prop] = true;
      const result = this.adminAddParameters[prop].match(this.regObj[prop]);
      if (result && result.length) {
        this.adminAddParameters[prop] = result.join('');
      } else {
        this.adminAddParameters[prop] = '';
      }
    } else {
      this.errObj[prop] = false;
    }
  }

  private inputCheck(event: any) {
    const target: {name: string; value: string} = event.target;
    const {name, value} = target;
    this.stringHandle(value, name as NeedCheckPropName);
  }

  private blurCheck(event: any) {
    const target: {name: string} = event.target;
    const {name} = target; 
    this.errObj[name as NeedCheckPropName] = false;
  }

  private isEmailValidated(email: string) {
    const regexTestResult = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    if (regexTestResult) {
      return true;
    }
    return false;
  }

  private isFormPassed() {
    const adminRole = this.adminRole;
    const adminName = this.adminName;
    const emailId = this.emailId;
    const emailDomain = this.emailDomain;

    const email = this.adminEmail;

    if (adminRole === '') {
      alert(this.toI18n('ADMIN_ADD_ALERT_SELECT_TYPE')); // 계정유형을 선택해 주세요.
      return false;
    } else if (adminRole === 'MASTER') {
      if (!adminName) {
        alert(this.toI18n('ADMIN_ADD_ALERT_ENTER_NAME')); // 운영자명을 입력해 주세요.
        return false;
      }

      if (emailId.length === 0 || emailDomain.length === 0) {
        alert(this.toI18n('ADMIN_ADD_ALERT_ENTER_EMAIL')); // e메일을 입력해주세요.
        return false;
      }

      if (!this.isEmailValidated(email)) {
        alert(this.toI18n('ADMIN_ADD_ALERT_CHECK_FORMAT')); // e메일 형식을 확인해주세요.
        return false;
      }

      if (!this.adminAddParameters.reasonDetail) {
        alert('사유를 입력해주세요.');
        return false;
      }
    } else if (adminRole === 'NORMAL') {
      if (!adminName) {
        alert(this.toI18n('ADMIN_ADD_ALERT_ENTER_NAME')); // 운영자명을 입력해 주세요.
        return false;
      }

      if (emailId.length === 0 || emailDomain.length === 0) {
        alert(this.toI18n('ADMIN_ADD_ALERT_ENTER_EMAIL')); // e메일을 입력해주세요.
        return false;
      }

      if (!this.isEmailValidated(email)) {
        alert(this.toI18n('ADMIN_ADD_ALERT_CHECK_FORMAT')); // e메일 형식을 확인해주세요.
        return false;
      }

      if (!this.adminAddParameters.reasonDetail) {
        alert('사유를 입력해주세요.');
        return false;
      }

      if (this.authorityGroupNo === '0') {
        alert(this.toI18n('ADMIN_ADD_ALERT_SELECT_GROUP')); // 권한 그룹을 선택해 주세요.
        return false;
      }
    }

    return true;
  }

  private goBack() {
    this.$router.push('/admin/list');
  }

  private save() {
    if (!this.isFormPassed()) {
      return;
    }

    if (!confirm(this.toI18n('ADMIN_ADD_ALERT_WOULD_YOU_REGISTRATION'))) {
      // 운영자 등록을 완료 하시겠습니까?
      return;
    }
    const adminRole = this.adminRole as AdminRole;
    const adminName = this.adminName;
    const adminEmail = this.adminEmail;
    const externalAccessEnabled = this.adminAddParameters.externalAccess === 'true';
    const expireDate = this.useExpire === 'true' && Boolean(this.expireDate) ? this.expireDate : null;
    const data: any = {
      adminRole,
      adminName,
      adminEmail,
      externalAccessEnabled,
      expireDate,
      reasonDetail: this.adminAddParameters.reasonDetail,
    };
    if (this.isAuthorityGroupsSettingShow) {
      const authorityGroupNo = this.authorityGroupNo;
      Object.assign(data, {authorityGroupNo});
    }

    this.$api.postAdminsService({data}).then((response: any): void => {
      const status = response.status;
      if (status === 201) {
        alert(this.toI18n('ADMIN_ADD_ALERT_SUCCESSFULLY')); // 신규 운영자가 정상 등록 되었습니다.
        this.goBack();
      }
    });
  }
}
